import LocalStorageManager from 'app/services/web-storage/LocalStorageManager';
import is from '@sindresorhus/is';

const TWO_DAYS_IN_MINUTES = 60 * 24 * 2;

export default class WatchedPlaylist {
  private readonly storeKey: string;
  private readonly localStorageManager: LocalStorageManager;

  constructor(playlistId: number) {
    this.storeKey = `playlist-${playlistId}`;
    this.localStorageManager = LocalStorageManager.getInstance();
  }

  watch(videoIndex: number) {
    if (this.isUpToDate(videoIndex)) {
      return;
    }
    this.updateVideoIndex(videoIndex);
  }

  private isUpToDate(videoIndex: number): boolean {
    const lastViewedVideoIndex = this.localStorageManager.getItem(this.storeKey);
    return is.number(lastViewedVideoIndex) && videoIndex <= lastViewedVideoIndex;
  }

  private updateVideoIndex(videoIndex: number) {
    this.localStorageManager.setItem(this.storeKey, videoIndex, TWO_DAYS_IN_MINUTES);
  }

  isWatched(playlistLength: number) {
    return this.isUpToDate(playlistLength - 1);
  }

  getWatchedVideoIndex(): number | null {
    return this.localStorageManager.getItem(this.storeKey);
  }
}
